import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { useTranslation } from 'react-i18next';
import {
    StyledGreenButton,
    StyledMediumTypography,
    StyledModalButtons,
    StyledModalDescription,
    StyledModalTitle,
    StyledWhiteButton
} from '../theme/StyledElements';
import { useNavigate } from 'react-router-dom';
import { logOut } from '../services/firebaseAuth';

const style = {
    position: 'absolute' as const,
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    minWidth: 360,
    bgcolor: 'background.paper',
    border: '2px solid #134C03'
};

interface LogoutModalProps {
    isModelOpen: boolean;
    setModelOpen: Function;
    onCancelClick: Function;
}

export function LogoutModal({
    isModelOpen,
    setModelOpen,
    onCancelClick
}: LogoutModalProps): JSX.Element {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const body = (
        <Box sx={style}>
            <StyledModalTitle>
                <Typography variant="body1" color="#FFFFFF">
                    {t('logout')}
                </Typography>
            </StyledModalTitle>
            <StyledModalDescription variant="h3">{t('logoutDescription')}</StyledModalDescription>
            <StyledModalButtons>
                <StyledWhiteButton onClick={(): void => onCancelClick()}>
                    <StyledMediumTypography variant="caption">{t('cancel')}</StyledMediumTypography>
                </StyledWhiteButton>
                <StyledGreenButton
                    onClick={async (): Promise<void> => {
                        await logOut();
                        navigate('/auth/login');
                    }}>
                    <StyledMediumTypography
                        variant="caption"
                        color="#FFFFFF"
                        sx={{ textTransform: 'uppercase' }}>
                        {t('logout')}
                    </StyledMediumTypography>
                </StyledGreenButton>
            </StyledModalButtons>
        </Box>
    );

    return (
        <Modal
            open={isModelOpen}
            onClose={(): void => {
                setModelOpen(false);
            }}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description">
            {body}
        </Modal>
    );
}
